import { render, staticRenderFns } from "./LogoRutify.vue?vue&type=template&id=3e8d6ddc&"
import script from "./LogoRutify.vue?vue&type=script&lang=js&"
export * from "./LogoRutify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports